export const getEventsUrl = 'safe-gpt/events/';
export const attendEventUrl = (eventId: string) => `safe-gpt/events/${eventId}/`;
export const getEventUrl = (eventId: string) => `safe-gpt/events/${eventId}/`;
export const gptAlarmTypesUrl = 'gpt/alarm/types/';
